import { Routes } from '@naruto/bgdapp/src/base/routes/types';

const Admin: Routes = {
  main: []
};

export default Admin;
